let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3P1iS")).then(() => parcelRequire('6G7Pc'));